export default __webpack_public_path__ + "static/media/profile-pic-2.75b2bc80.jpeg";